"use client";

import { useEffect } from "react";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { Button } from "@/components/Button/Button";
import { Section } from "@/components/Section/Section";
import { ErrorBoundaryProps } from "@/types/ErrorBoundaryType";
import styles from "./error.module.scss";

const Error = ({ error, reset }: ErrorBoundaryProps) => {
  const { label } = useGlobalContext();

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main id="main-content">
      <Section
        className={styles["error-section"]}
        columnsClassName="is-multiline"
        containerClassName="has-text-centered is-small"
      >
        <div
          role="alert"
          className="column is-flex is-12 is-flex-direction-column is-align-items-center"
        >
          <h1 className="h1-pages">
            {label("global", "error", "nextjs_headline", {
              de: "Etwas ist schiefgelaufen",
              en: "Something went wrong",
            })}
          </h1>
          <p className="content">
            {label("global", "error", "nextjs_message", {
              de: "Beim Laden dieser Seite ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
              en: "An error occurred while loading this page. Please try again.",
            })}
          </p>
          <Button href="" type="primary" target="_self" onClick={() => reset()}>
            <strong>
              {label("global", null, "nextjs_error_retry", {
                de: "Erneut versuchen",
                en: "Retry",
              })}
            </strong>
          </Button>
        </div>
      </Section>
    </main>
  );
};

export default Error;
